import React from "react";

const ContactForm = () => {
  return (
    <div style={{ backgroundColor: "rgb(245, 248, 250)" }} className="d-flex justify-content-center">

 
    <div className="section-container w-100" style={{ margin: "auto" }}>
      <div style={{ backgroundColor: "rgb(245, 248, 250)" }}>
        <div style={{ height: "2rem" }}></div>
        <div className="contact-container d-flex align-items-center ">
          <iframe
            src="https://meetings.hubspot.com/carly-weitz/insight-suite?uuid=f2142971-9708-4ce6-8872-98d4f2441fc2"
            title="External Page"
            width="100%"
            height="900px"
            style={{
              border: "none",
              display: "flex",
              alignItems: "center",
            }}
          />
        </div>
        <div style={{ height: "2rem" }}></div>
      </div>
    </div>
    </div>
  );
};

export default ContactForm;
